<template>
    <main>
        <div class="container-fluid">
            <div class="row">
               <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="mainButton">
                        <breadcrumbs></breadcrumbs>
                    </div>
                    <div class="page-toolbar">
                        <div class="page-title">
                            <span class="title">Edit Comment</span> 
                            <span class="star"> <i class="fa-solid fa-star"></i></span>
                        </div>
                       
                    </div>
                </div>
            </div>
        </div>
        <GenericEdit v-if="generic" ref="loadGeneric" :urls="urls"></GenericEdit>
        <CustomEdit v-else></CustomEdit>  
    </main> 
</template>

<script>
    import { ref } from "vue";
    import breadcrumbs from "@/views/modules/Comments/MenuList.vue";
    import lang from "@/views/modules/Comments/language/en";
    import GenericEdit from "@/components/layout/shared/generic/EditView.vue";
    import CustomEdit from "@/views/modules/Comments/EditView.vue";

    export default {
        name: "new-comment",
        components: {
            breadcrumbs,
            GenericEdit,
            CustomEdit,
        },
        data() {
            return {
                generic: true,
                metaList: [
                    {
                        type: 'text',
                        name: 'name',
                        label: lang.LBL_COMMENT_NAME,
                        required: true
                    },
                    {
                        type: 'text',
                        name: 'parent_type',
                        label: lang.LBL_PARENT_TYPE,
                        required: true
                    },
                    {
                        type: 'text',
                        name: 'parent_id',
                        label: lang.LBL_PARENT_ID,
                        required: true
                    },
                    {
                        type: 'textarea',
                        name: 'description',
                        label: lang.LBL_DESCRIPTION,
                        required: true
                    },
                ],

                urls: 'api/modules/comments',

                routePath: {
                    path: 'comments',
                    detail: false
                }
            }
        },
        mounted() {
            this.childMethod()
        },
        methods: {
            childMethod() {
                if (this.generic == true) {
                    this.$refs.loadGeneric.loadGenericView(this.metaList, this.routePath);
                }
            }
        },
    }
</script>